import { render } from "./IconArrow.vue?vue&type=template&id=34fe55a2"
import script from "./IconArrow.vue?vue&type=script&lang=js"
export * from "./IconArrow.vue?vue&type=script&lang=js"
script.render = render

export default script